/**
 * Step 1: Create AHU entity with base configuration
 */
import { IBotData } from '../../../../models';
import { ahuApi } from '../../../../services';
import { dispatchMutation } from '../../../../utils/dispatch.utils';

export async function step1CreateAHU(
  botData: IBotData,
  projectId: number,
  getOptions: () => { signal?: AbortSignal },
  onAhuCreated?: (ahuId: number) => void
): Promise<number> {
  const ahuResult = await dispatchMutation<{ id: number }>(
    ahuApi.endpoints.createAHU,
    {
      body: {
        project_id: projectId,
        qty: 1,
        tag: botData.tag,
        construction_class_id: botData.construction_class_id,
      },
    },
    getOptions()
  );

  const ahuId = ahuResult.id;
  onAhuCreated?.(ahuId);

  // Set localStorage
  if (typeof window !== 'undefined') {
    localStorage.setItem('bot', 'true');
  }

  return ahuId;
}

